import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { dateFormatter } from "../../../../utils/UtilityFunctions";

function NavSearch({ data, onClose }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const results = useMemo(() => {
    if (!data || !query.trim()) return [];
    const needle = query.trim().toLowerCase();
    return data
      .filter((d) => d.logDate)
      .map((d) => {
        const iso = d.logDate.substring(0, 10);
        const [year, month, dayOfMonth] = iso.split("-");
        return {
          id: d.id,
          date: dateFormatter(iso),
          // Matching only the formatted date meant "2026-10-07" and "7/10"
          // found nothing, which is how most people type a date.
          haystack: [
            dateFormatter(iso),
            iso,
            `${dayOfMonth}/${month}/${year}`,
            `${dayOfMonth}/${month}`,
          ]
            .join(" ")
            .toLowerCase(),
        };
      })
      .filter((d) => d.haystack.includes(needle));
  }, [data, query]);

  return (
    <div className="navsearch">
      <div className="navsearch__bar">
        <input
          autoFocus
          className="navsearch__input"
          type="search"
          placeholder="Search your journal by date…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button className="navsearch__close" onClick={onClose} aria-label="Close search">
          ✕
        </button>
      </div>

      {results.length > 0 && (
        <ul className="navsearch__results">
          {results.map((d) => (
            <li key={d.id}>
              <button
                className="navsearch__result"
                onClick={() => {
                  navigate(`/today/${d.id}`);
                  onClose();
                }}
              >
                {d.date}
              </button>
            </li>
          ))}
        </ul>
      )}

      {query.trim() && results.length === 0 && (
        <p className="navsearch__empty">No entries found for "{query}"</p>
      )}
    </div>
  );
}

export default NavSearch;
